<template>
    <div class="generalSettings">
        <b-form-checkbox v-model="alwaysShowImages" class="mb-3"
                :disabled="!$store.state.settings.allowwebmailimages">{{$t('alwaysshowimages')
            }}</b-form-checkbox>

        <b-form-group :label="$t('language')">
            <b-select v-model="language" :options="languageOptions"
                    @input="changeLanguage"></b-select>
        </b-form-group>

        <b-form-group :label="$t('mailboxQuota')">
          <b-input :value="quotaText" readonly></b-input>
        </b-form-group>

        <b-form-group :label="$t('sendQuota')">
          <div class="sendQuota"><table v-html="sendQuotaText"></table></div>
        </b-form-group>

        <b-button :disabled="$v.$invalid || saving || !$store.state.settingsLoaded" variant="primary" @click="doSave">
            {{$t('save')}}
        </b-button>
        <font-awesome-icon :class="{ saveIcon: true, savingIcon: saving }" spin
                icon="spinner-third"></font-awesome-icon>
        <span class="error">{{saveError}}</span>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import axios from 'axios';
import { EventBus } from '@/event-bus';

export default {
  name: 'generalSettings',
  components: { FontAwesomeIcon },
  data: function() {
    return {
      alwaysShowImages: false,
      saving: false,
      saveError: '',
      languages: {},
      language: '',
      quota: 0,
      sendquota: '',
      mailboxsize: -1,
      smtpstats: null
    };
  },
  i18nOptions: { keyPrefix: 'settings.general' },
  validations: {

  },
  created() {
    EventBus.$on('settingsLoaded', () => {
      this.initSettings();
    });
  },
  mounted() {
    this.initSettings();
  },
  methods: {
    initSettings() {
      this.alwaysShowImages = this.$store.state.settings.alwaysshowimages &&
        this.$store.state.settings.allowwebmailimages;

      this.quota = this.$store.state.settings.quota;
      this.sendquota = this.$store.state.settings.sendquota;

      this.languages = this.$store.state.availableLanguages;
      axios.get('/rest/login/languages/user')
        .then(d => {
          console.log('getLanguages in Settings', d);
          this.languages = d.data;
          this.$store.commit('setAvailableLanguages', { languages: d.data });
        });
      let language = this.$store.state.language.toLowerCase();
      if (!this.languages[language]) {
        language = 'en';
      }
      console.log('settings language', language);
      this.language = language;

      axios.get('/rest/user/stats/mailboxsize')
        .then(d => {
          console.log('got mailboxsize', d);
          this.mailboxsize = d.data.mailboxsize;
        });
      axios.get('/rest/user/stats/sendstats')
        .then(d => {
          console.log('got sendstats', d);
          this.smtpstats = d.data;
        });
    },
    changeLanguage(lang) {
      this.$i18n.i18next.changeLanguage(lang);
    },
    doSave() {
      let settings = {
        alwaysshowimages: this.alwaysShowImages
      };
      this.$store.dispatch('setLanguage', { language: this.language });
      this.saving = true;
      axios.patch('/rest/user/settings', settings)
        .then(d => {
          console.log(d);
          this.saveError = '';
        })
        .catch(e => {
          console.dir(e);
          this.saveError = this.$t('saveError');
        })
        .finally(() => {
          this.saving = false;
        });
    }
  },
  computed: {
    languageOptions() {
      return Object.keys(this.languages).map(l => {
        return { text: this.languages[l].name, value: l };
      });
    },
    quotaText() {
      if (this.mailboxsize === -1) {
        if (this.quota === 0) {
          return this.$t('mailboxNoQuotaNoData');
        } else {
          return this.$t('mailboxQuotaNoData', { quota: this.quota });
        }
      } else {
        if (this.quota === 0) {
          return this.$t('mailboxNoQuotaData', { used: this.mailboxsize });
        } else {
          return this.$t('mailboxQuotaData', { used: this.mailboxsize, quota: this.quota });
        }
      }
    },
    sendQuotaText() {
      const lines = this.sendquota.split('\n');
      let usageText = '';
      if (lines.length === 0) {
        lines[0] = '24~h~~0~0~0~0~0~0~0~0';
      }

      let quotaParts = lines[0].split('~');
      let timeText = '';
      console.log('quotaParts', quotaParts);
      let limitCount = 0;
      for (let i = 0; i < quotaParts.length; i++) {
        if ((i !== 1) && (i !== 2)) {
          quotaParts[i] = parseInt(quotaParts[i]);
          if ((i > 2) && (quotaParts[i] > 0)) {
            limitCount++;
          }
        }
      }
      if (quotaParts[2] === '') {
        if (quotaParts[1] === 'h') {
          timeText = this.$t('sendTimeLatestHours', { count: quotaParts[0] });
        } else if (quotaParts[1] === 'd') {
          timeText = this.$t('sendTimeLatestDays', { count: quotaParts[0] });
        } else if (quotaParts[1] === 'm') {
          timeText = this.$t('sendTimeLatestMonths', { count: quotaParts[0] });
        }
      } else {
        let timeStart = quotaParts[2];
        if (this.smtpstats === null || !this.smtpstats.PeriodStart) {
          timeStart = quotaParts[2].substring(0, 4) + '-' +
              quotaParts[2].substring(4, 6) + '-' +
              quotaParts[2].substring(6, 8) + 'T' +
              quotaParts[2].substring(8, 10) + ':' +
              quotaParts[2].substring(10, 12) + ':' +
              quotaParts[2].substring(12, 14);
        } else {
          timeStart = this.smtpstats.PeriodStart;
        }

        if (quotaParts[1] === 'h') {
          timeText = this.$t('sendTimeHoursSince', { count: quotaParts[0], start: timeStart });
        } else if (quotaParts[1] === 'd') {
          timeText = this.$t('sendTimeDaysSince', { count: quotaParts[0], start: timeStart });
        } else if (quotaParts[1] === 'm') {
          timeText = this.$t('sendTimeMonthsSince', { count: quotaParts[0], start: timeStart });
        }
      }

      if (limitCount === 0) {
        if (this.smtpstats === null) {
          return this.$t('sendQuotaNoneNoDataText');
        } else {
          usageText = this.$t('sendQuotaNoneData',
            { messages: this.$t('sendQuotaMessages', { count: this.smtpstats.TotalMessages }),
              size: this.$t('sendQuotaSize', { size: this.smtpstats.TotalSize }) });
          return this.$t('sendQuotaNoneDataText', { usage: usageText, time: timeText });
        }
      } else {
        let limitText = '';
        if (this.smtpstats === null) {
          for (let i = 3; i < 11; i++) {
            if (quotaParts[i] > 0) {
              limitText += this.$t('sendQuotaNoDataLimit_' + i, { count: quotaParts[i] });
            }
          }
          return this.$t('sendQuotaNoDataText', { usage: limitText, time: timeText });
        } else {
          for (let i = 3; i < 11; i++) {
            if (quotaParts[i] > 0) {
              let usage = -1;
              let className = 'okquota';

              switch (i) {
                case 3:
                  usage = this.smtpstats.TotalMessages;
                  break;
                case 4:
                  usage = this.smtpstats.RemoteMessages;
                  break;
                case 5:
                  usage = this.smtpstats.TotalRecipients;
                  break;
                case 6:
                  usage = this.smtpstats.RemoteRecipients;
                  break;
                case 7:
                  usage = this.smtpstats.TotalSize;
                  break;
                case 8:
                  usage = this.smtpstats.RemoteSize;
                  break;
                case 9:
                  usage = this.smtpstats.TotalRecipientSize;
                  break;
                case 10:
                  usage = this.smtpstats.RemoteRecipientSize;
                  break;
              }
              if (usage >= quotaParts[i]) {
                className = 'overquota';
              } else if (usage >= quotaParts[i] * 80 / 100) {
                className = 'nearquota';
              }
              limitText += this.$t('sendQuotaText_' + i,
                { className,
                  usage: this.$t('sendQuotaUsage_' + i, { count: usage, className }),
                  limit: this.$t('sendQuotaLimit_' + i, { count: quotaParts[i], className }) });
            }
          }
          return this.$t('sendQuotaText', { usage: limitText, time: timeText });
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .saveIcon {
        color: transparent;
        margin: 0 5px;
    &.savingIcon {
         color: black;
     }
    }

    .error {
        color: $danger;
    }
</style>

<style lang="scss">
    @import '../assets/bootstrap-style.scss';

    div.sendQuota {
      background-color: $gray-200;
      width: 100%;
      padding: 0.375rem 0.75rem;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      table {
        width: 100%;
        th {
          font-weight: bold;
        }
        tr.nearquota {
          color: $danger;
        }
        tr.overquota {
          background-color: $danger;
          color: $light;
        }
        tr.noquota td {
          text-align: left !important;
        }
        td {
          padding-right: 1ex;
        }
        td:nth-child(1) {
          text-align: right;
        }
        td:nth-child(5) {
          width:100%;
        }
      }
    }
</style>
